import { Node, Edge } from 'reactflow';

// Node Styles
export const BASE_NODE_STYLE = {
  borderRadius: 8,
  borderColor: '#1a192b',
  padding: 12,
  fontSize: 12,
  width: 280,
  whiteSpace: 'pre-wrap' as const,
  backgroundColor: '#fff',
  cursor: 'pointer', // Hand cursor when hovering over draggable nodes
};

export const START_NODE_STYLE = {
  ...BASE_NODE_STYLE,
  borderColor: '#1976d2',
  border: '1px solid #1976d2', // Explicit border for React Flow default nodes
};

export const END_NODE_STYLE = {
  ...BASE_NODE_STYLE,
  borderColor: '#2e7d32',
  border: '1px solid #2e7d32', // Explicit border for React Flow default nodes
};

export const CONDITIONAL_NODE_STYLE = {
  ...BASE_NODE_STYLE,
  borderColor: '#d32f2f',
};

// Layout Constants
export const BASE_X = 400; // Center column for main flow
export const CONDITIONAL_LEFT_X = 100; // Left side for conditional branches
export const CONDITIONAL_RIGHT_X = 700; // Right side for conditional branches
export const VERTICAL_SPACING = 180; // Increased spacing for better organization
export const CONDITIONAL_OFFSET_Y = 60; // Vertical offset for conditionals relative to source

// Edge Styles
export const CONDITIONAL_EDGE_STYLE = { strokeDasharray: '6 4', stroke: '#d32f2f' };

// Node Creation Functions
export const createStartNode = (): Node => ({
  id: 'start',
  type: 'input',
  data: { label: 'Start' },
  position: { x: BASE_X, y: 0 },
  style: START_NODE_STYLE,
});

export const createEndNode = (): Node => ({
  id: 'end',
  type: 'output',
  data: { label: 'Done' },
  position: { x: BASE_X, y: VERTICAL_SPACING * 2 }, // Moved down to make room for default question
  style: END_NODE_STYLE,
});

export const createDefaultQuestionNode = (): Node => ({
  id: '1',
  type: 'question',
  data: { label: 'Q1: Question 1' },
  position: { x: BASE_X, y: VERTICAL_SPACING }, // Position between start and end
  style: BASE_NODE_STYLE,
});

// Initial Flow State
export const INITIAL_NODES: Node[] = [
  createStartNode(),
  createDefaultQuestionNode(),
  createEndNode(),
];

export const INITIAL_EDGES: Edge[] = [
  {
    id: 'edge-start-1',
    source: 'start',
    target: '1',
    type: 'smoothstep',
    data: { linear: true },
    reconnectable: true,
    sourceHandle: 'bottom-output', // Connect from start's bottom handle
    targetHandle: 'top-input', // Connect to question's top handle
  },
  {
    id: 'edge-1-end',
    source: '1',
    target: 'end',
    type: 'smoothstep',
    data: { linear: true },
    reconnectable: true,
    sourceHandle: 'bottom-output', // Connect from question's bottom handle
    targetHandle: 'top-input', // Connect to end's top handle
  },
];

